var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _path6, _path7, _circle6, _path8, _path9, _circle7, _circle8, _path0, _path1, _circle9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrengthTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 148,
    viewBox: "0 0 268 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.0005 99C113.092 99 131 81.0914 131 59C131 36.9086 113.092 19 91.0005 19C68.9091 19 51.0005 36.9086 51.0005 59C51.0005 81.0914 68.9091 99 91.0005 99Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106 146C134.719 146 158 122.719 158 94C158 65.2812 134.719 42 106 42C77.2817 42 54.0005 65.2812 54.0005 94C54.0005 122.719 77.2817 146 106 146Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155 147C181.51 147 203 125.51 203 99C203 72.4903 181.51 51 155 51C128.491 51 107 72.4903 107 99C107 125.51 128.491 147 155 147Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177 126C203.51 126 225 104.51 225 78C225 51.4903 203.51 30 177 30C150.491 30 129 51.4903 129 78C129 104.51 150.491 126 177 126Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141 96C167.51 96 189 74.5097 189 48C189 21.4903 167.51 0 141 0C114.491 0 93.0005 21.4903 93.0005 48C93.0005 74.5097 114.491 96 141 96Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 207,
    cy: 16,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0005,
    cy: 84,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 66,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 221.5,
    cy: 144.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5005,
    cy: 146.5,
    r: 1.5,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.155 79.2314L158.174 64.9029C156.546 59.0391 159.98 52.9968 166.016 52.2146C169.016 51.8257 172.437 51.5391 176.001 51.5391C179.565 51.5391 182.985 51.8257 185.986 52.2146C192.021 52.9968 195.456 59.0391 193.827 64.9029L189.847 79.2314",
    stroke: "#B3262D",
    strokeWidth: 8.30769
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176 68.1543C190.53 68.1543 202.308 79.9326 202.308 94.4619C202.308 102.221 198.948 109.195 193.604 114.01C192.689 114.835 191.478 115.231 190.245 115.231H161.756C160.523 115.231 159.312 114.835 158.397 114.01C153.053 109.195 149.693 102.221 149.693 94.4619C149.693 79.9326 161.471 68.1543 176 68.1543Z",
    fill: "#B3262D"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 93.0769,
    r: 11.0769,
    fill: "#B3262D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1545 79.2314L78.1744 64.9029C76.5456 59.0391 79.9802 52.9968 86.0155 52.2146C89.0161 51.8257 92.4367 51.5391 96.0007 51.5391C99.5646 51.5391 102.985 51.8257 105.986 52.2146C112.021 52.9968 115.456 59.0391 113.827 64.9029L109.847 79.2314",
    stroke: "#B3262D",
    strokeWidth: 8.30769
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0005 68.1543C110.53 68.1543 122.308 79.9326 122.308 94.4619C122.308 102.221 118.948 109.195 113.604 114.01C112.689 114.835 111.478 115.231 110.245 115.231H81.7558C80.5232 115.231 79.3123 114.835 78.3966 114.01C73.0529 109.195 69.6929 102.221 69.6929 94.4619C69.6929 79.9326 81.4712 68.1543 96.0005 68.1543Z",
    fill: "#B3262D"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.0003,
    cy: 93.0769,
    r: 11.0769,
    fill: "#B3262D"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5005,
    cy: 5.5,
    r: 1.5,
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M116 72L110.251 51.3033C107.899 42.8334 112.86 34.1056 121.578 32.9758C125.912 32.4141 130.853 32 136 32C141.148 32 146.089 32.4141 150.423 32.9758C159.141 34.1056 164.102 42.8334 161.75 51.3033L156 72",
    stroke: "#EA4C54",
    strokeWidth: 12
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M136 56C156.987 56 174 73.0132 174 94C174 105.207 169.148 115.281 161.43 122.236C160.107 123.428 158.358 124 156.578 124H115.423C113.643 124 111.894 123.428 110.571 122.236C102.853 115.281 98.0005 105.207 98.0005 94C98.0005 73.0132 115.014 56 136 56Z",
    fill: "#EA4C54"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 92,
    r: 16,
    fill: "#DA4149"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M236 117L266 125",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M238 33L260 23",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00049 23L29.0005 31",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00049 132L34.0005 121",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrengthTraining);
export default __webpack_public_path__ + "static/media/strength-training.f95083eb265d9e8e646005f5f94279e5.svg";
export { ForwardRef as ReactComponent };